import * as types from "../types";

const state = {
  tradingViewData: []
};

const getters = {
  [types.tradingView.getters.GET_TRADING_VIEW_DATA]: state => {
    return state.tradingViewData;
  }
};

const mutations = {
  [types.tradingView.mutations.MUTATE_TRADING_VIEW_DATA]: (state, payload) => {
    state.tradingViewData = payload;
  }
};

const actions = {
  [types.tradingView.actions.SET_TRADING_VIEW_DATA]: ({ commit }, payload) => {
    commit(types.tradingView.mutations.MUTATE_TRADING_VIEW_DATA, payload);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
